























































import { Component, Prop, Vue } from 'vue-property-decorator'
import AuthService from './services/AuthService'

@Component
class App extends Vue {
  public auth: AuthService = new AuthService()
  public authenticated: boolean = false

  public created () {
    this.authenticated = this.auth.isAuthenticated()
    this.auth.authNotifier.on('authChange', (authState) => {
      this.authenticated = authState.authenticated
    })
  }

  public login () {
    this.auth.login()
  }

  public logout () {
    this.auth.logout()
  }
}

export default App
